import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_adjustment_by_current_date_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, Employee?: string, OperationCodeId?: number, OperationCode?: { Name?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { CommodityCode?: string, CountryOfOrigin?: string, LookupCode?: string, ProcedureCode?: string, ReceiveDate?: string }, VendorLot?: { LookupCode?: string, Vat?: string }, Warehouse?: { Name?: string }, ActualSourceLocation?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, Employee?: string, OperationCodeId?: number, OperationCode?: { Name?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { CommodityCode?: string, CountryOfOrigin?: string, LookupCode?: string, ProcedureCode?: string, ReceiveDate?: string }, VendorLot?: { LookupCode?: string, Vat?: string }, Warehouse?: { Name?: string }, ActualSourceLocation?: { Name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, Employee?: string, OperationCodeId?: number, OperationCode?: { Name?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { CommodityCode?: string, CountryOfOrigin?: string, LookupCode?: string, ProcedureCode?: string, ReceiveDate?: string }, VendorLot?: { LookupCode?: string, Vat?: string }, Warehouse?: { Name?: string }, ActualSourceLocation?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId: number    }) {
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
